import Configuracao from '@/util/Configuracao';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/**
 * @classdesc Agrupa as regras semânticas relacionadas aos dados do processo.
 */
export default class ProcessoFormatter {
    static FORMATO_DATAHORA_ENTRADA = Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO;

    static formatoSaida(exibirHora) {
        return exibirHora ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY';
    }

    /**
     * Formata a data julgamento do processo.
     *
     * @param {string} dataJulgamentoProcesso - Data de julgamento do processo no formato de resposta do servidor .
     * @param {boolean} exibirHora - Se deve incluir a hora na formatação.
     * @returns {string} Informação com a data de julgamento do processo.
     */
    static formatarDataJulgamentoProcesso(dataJulgamentoProcesso, exibirHora = true) {
        const dataObj = dayjs(dataJulgamentoProcesso, this.FORMATO_DATAHORA_ENTRADA);
        return dataObj.format(this.formatoSaida(exibirHora));
    }
}
